/**
 * 2行以上の連続の改行を削除する
 * @param value 対象の文字列
 * @returns
 */
export const removeNewLines = (value: string) => {
  return value.replace(/(\r\n){3,}|\r{3,}|\n{3,}/g, '\n\n');
};

/**
 * 末尾についている改行を全て削除する
 * @param value 対象の文字列
 * @returns
 */
export const removeEndNewLines = (value: string) => {
  return value.replace(/\r*$|\r\n*$|\n*$/, '');
};
